export const navLinks = [
  { id: 'entrance', label: '入口总览', href: '#entrance' },
  { id: 'address', label: '最新地址', href: '#address' },
  { id: 'download', label: 'APP 下载', href: '#download' },
  { id: 'tags', label: '话题墙', href: '#tags' },
  { id: 'faq', label: '常见问题', href: '#faq' },
];

export const heroMeta = [
  { id: 'update', icon: 'ri-refresh-line', label: '最近校验', value: '2026-10-10' },
  { id: 'count', icon: 'ri-link', label: '收录入口', value: '6 条可用' },
  { id: 'status', icon: 'ri-shield-check-line', label: '官方网址', value: '状态正常' },
];

export const entranceCards = [
  {
    id: 'official',
    no: '01',
    icon: 'ri-global-line',
    title: '官网直达入口',
    desc: '首选主线路，打开即为青苹果影院官网首页，地址失效时优先在这里取最新入口。',
    badge: '主线路',
    accent: 'primary',
    href: '#address',
  },
  {
    id: 'address',
    no: '02',
    icon: 'ri-links-line',
    title: '最新地址合集',
    desc: '汇总近期仍可访问的最新地址，按校验时间排序，逐条标注可用状态，避免白跑一趟。',
    badge: '实时收录',
    accent: 'secondary',
    href: '#address',
  },
  {
    id: 'app',
    no: '03',
    icon: 'ri-download-2-line',
    title: 'APP 下载中心',
    desc: '安卓、iOS、电视与电脑客户端下载方式集中整理，一次找齐，不用来回翻找。',
    badge: '全端覆盖',
    accent: 'accent',
    href: '#download',
  },
  {
    id: 'backup',
    no: '04',
    icon: 'ri-route-line',
    title: '备用线路索引',
    desc: '当主地址被访问受限时，按索引切换备用线路，对应网址与进入方式都已列清。',
    badge: '应急备用',
    accent: 'secondary',
    href: '#address',
  },
];

export const coverStrip = [
  {
    id: 'cover-01',
    title: '热映影片',
    sub: '在线观看',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20movie%20cover%20art%20with%20deep%20emerald%20green%20and%20warm%20amber%20gradient%20shapes%20on%20a%20dark%20background%2C%20minimal%20geometric%20design%2C%20no%20text%2C%20premium%20poster%20aesthetic%2C%20consistent%20visual%20style&width=800&height=1100&seq=qpg-cover-01&orientation=portrait',
  },
  {
    id: 'cover-02',
    title: '热播剧集',
    sub: '高清资源',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20cover%20design%20with%20layered%20teal%20and%20soft%20lime%20gradient%20shapes%20on%20a%20charcoal%20background%2C%20minimal%20editorial%20poster%20composition%2C%20no%20text%2C%20elegant%20premium%20mood&width=800&height=1100&seq=qpg-cover-02&orientation=portrait',
  },
  {
    id: 'cover-03',
    title: '综艺动漫',
    sub: '每日更新',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20cover%20art%20with%20deep%20forest%20green%20and%20muted%20gold%20gradient%20blocks%20on%20a%20dark%20background%2C%20minimal%20geometric%20poster%20design%2C%20no%20text%2C%20refined%20premium%20visual%20style&width=800&height=1100&seq=qpg-cover-03&orientation=portrait',
  },
];

export const bookmarkReasons = [
  {
    id: 'reason-1',
    icon: 'ri-bookmark-3-line',
    title: '一次收藏，长期有效',
    desc: '入口与最新地址都会在本页持续更新，把页面加入书签，下次直接回来即可，不必再凭记忆找网址。',
  },
  {
    id: 'reason-2',
    icon: 'ri-loop-right-line',
    title: '地址失效也能接上',
    desc: '当原地址打不开时，本页会补充可用线路，跟着索引切换就行，不用在各类帖子之间来回翻。',
  },
  {
    id: 'reason-3',
    icon: 'ri-smartphone-line',
    title: '网页与 APP 都覆盖',
    desc: '无论你习惯直接用浏览器影视观看，还是更想下载客户端，官网入口与 APP 下载方式都在同一页说明。',
  },
];

export const addressList = [
  {
    id: 'addr-1',
    name: '官网主入口',
    domain: 'qpgmovie-official.com',
    note: '默认主线路',
    updated: '10-10 09:20',
    status: 'available',
  },
  {
    id: 'addr-2',
    name: '最新地址 · 一号线路',
    domain: 'qpg-cinema-entry.net',
    note: '近期更新',
    updated: '10-10 08:45',
    status: 'available',
  },
  {
    id: 'addr-3',
    name: '最新地址 · 二号线路',
    domain: 'qpg-move-line.cc',
    note: '访问较快',
    updated: '10-09 22:10',
    status: 'available',
  },
  {
    id: 'addr-4',
    name: '移动端专用入口',
    domain: 'm.qpg-cinema-entry.net',
    note: '手机浏览器推荐',
    updated: '10-09 20:30',
    status: 'available',
  },
  {
    id: 'addr-5',
    name: '备用线路 · 应急',
    domain: 'qpg-backup-watch.io',
    note: '主线路异常时使用',
    updated: '10-09 18:05',
    status: 'backup',
  },
  {
    id: 'addr-6',
    name: '旧版地址（历史）',
    domain: 'qpg-cinema-old.org',
    note: '已停止维护',
    updated: '09-28 11:40',
    status: 'offline',
  },
];

export const downloadOptions = [
  {
    id: 'android',
    icon: 'ri-android-line',
    title: '安卓客户端',
    meta: 'APK · 约 42.6 MB',
    desc: '适配主流安卓系统，安装后可直接进入影视观看界面，支持高清线路切换。',
    badge: '推荐',
  },
  {
    id: 'ios',
    icon: 'ri-apple-line',
    title: 'iOS 客户端',
    meta: '描述文件 · 约 38.2 MB',
    desc: 'iPhone / iPad 按说明添加描述文件后即可安装，全程无需复杂设置。',
    badge: '常用',
  },
  {
    id: 'tv',
    icon: 'ri-tv-2-line',
    title: '电视 TV 版',
    meta: '大屏版 · 约 55.4 MB',
    desc: '面向智能电视与电视盒子，遥控器操作顺畅，客厅大屏观看体验更好。',
    badge: '',
  },
  {
    id: 'pc',
    icon: 'ri-computer-line',
    title: '电脑桌面版',
    meta: 'Windows · 约 96.8 MB',
    desc: '适合在电脑上长时段观看，支持窗口与全屏模式，资源加载更稳定。',
    badge: '',
  },
];

export const topicTags = [
  '影视观看',
  '官网入口',
  '最新地址',
  'APP下载',
  '官方网址',
  '在线观看',
  '高清资源',
  '热播剧集',
  '最新电影',
  '综艺娱乐',
  '动漫番剧',
  '备用线路',
  '蓝光画质',
  '每日更新',
  '收藏入口',
  '免安装观看',
];

export const steps = [
  {
    id: 'step-1',
    no: 'STEP 01',
    icon: 'ri-bookmark-line',
    title: '先收藏本页',
    desc: '把当前页面加入浏览器书签或收藏夹，之后无论入口怎么变，都能从这里重新定位。',
  },
  {
    id: 'step-2',
    no: 'STEP 02',
    icon: 'ri-links-line',
    title: '选一条可用线路',
    desc: '在最新地址合集里挑状态为「可用」的地址打开；需要客户端就转到 APP 下载区。',
  },
  {
    id: 'step-3',
    no: 'STEP 03',
    icon: 'ri-play-circle-line',
    title: '开始影视观看',
    desc: '进入后按页面提示完成播放即可，遇到卡顿换一条线路通常就能恢复。',
  },
];

export const faqs = [
  {
    id: 'faq-1',
    q: '青苹果影院官网入口打不开怎么办？',
    a: '先确认网络是否正常，再回到本页查看「最新地址合集」中的可用线路，通常更换一条线路即可恢复访问；如果仍打不开，可尝试备用线路索引中的应急入口。',
  },
  {
    id: 'faq-2',
    q: '最新地址多久更新一次？',
    a: '本页会随可用性校验结果持续补充与调整，建议收藏页面后定期回访。页面顶部的「最近校验」时间能帮你判断当前记录的新鲜度。',
  },
  {
    id: 'faq-3',
    q: 'APP 下载安装需要注意什么？',
    a: '请优先在 APP 下载中心按系统选择对应客户端，安卓安装时如出现安全提示选择继续安装即可；iOS 需按说明添加描述文件后再返回设置完成信任。',
  },
  {
    id: 'faq-4',
    q: '这里收录的官方网址可靠吗？',
    a: '本页只做入口与地址的整理索引，不承载内容，也不要求填写任何账号或支付信息。遇到要求额外付费或输入密码的页面请谨慎辨别。',
  },
  {
    id: 'faq-5',
    q: '为什么建议收藏本页而不是记住网址？',
    a: '网址会因线路调整而变化，单独记住一个地址容易失效。收藏本页后，无论入口如何变化，你都能在同一处找到当前可用的官网入口与最新地址。',
  },
];